























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { shortStr } from '@/utils';

@Component
export default class UploadButton extends Vue {
  // 默认图标mdi名称
  @Prop({ default: 'mdi-cloud-upload' })
  public mdiIcon!: string;
  // 图标默认名称
  @Prop({ default: 'PDF/图片 上传' })
  public defaultButtonText!: string;
  // 是否修改图标名称
  @Prop({ default: true })
  public canEditButtonText!: boolean;
  // 多选, 多选时图片永远是默认名称
  @Prop({ type: Boolean, default: false })
  public multiple!: boolean;
  // 文件类型
  @Prop({ type: String, required: true, default: 'application/pdf, image/*' })
  public inputAccept!: string;
  // 文件列表, 原来已选中的
  @Prop({ type: FileList })
  public fileList?: FileList;
  // 这次操作中 已选中的 文件列表
  public selectedFileList?: FileList | null;
  public isSelecting = false;

  public buttonText() {
    let text = this.defaultButtonText;
    if (!this.canEditButtonText) {
      return shortStr(text, length = 10);
    }
    const validFileList = this.selectedFileList || this.fileList;
    // console.log(text, 'multiple', this.multiple);
    if (this.multiple) {
      const num = validFileList?.length;
      if (num) {
        text = `已选择 ${num} 个`;
      }
    } else {
      text = validFileList?.[0].name ?? text;
    }
    return shortStr(text, length = 10);
  }

  public onButtonClick() {
    // this.isSelecting = true;
    // window.addEventListener('focus', () => {
    //   this.isSelecting = false;
    // }, { once: true });
    (this.$refs.uploader as HTMLElement).click();
  }

  @Emit('update:fileList')
  public fileListChanged(e: Event): FileList | null {
    const selectedFileList = (e.target as HTMLInputElement).files;
    // 如果input未选中，也会返回之前的FileList对象（但里面的内容已经被清空）
    if (selectedFileList?.length) {
      this.selectedFileList = selectedFileList;
    }
    this.$forceUpdate();
    return this.selectedFileList || this.fileList || null;
  }

  @Watch('fileList')
  public clearNullFileList(newVal) {
    if (newVal === null) {
      this.selectedFileList = null;
      (this.$refs.uploader as HTMLInputElement).value = '';
      this.$forceUpdate();
    }
  }

}
